"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EventDispatcher = /** @class */ (function () {
    function EventDispatcher() {
        this.listners = {};
        this.listners = {};
    }
    /**@description Add a listner to this type
     * @param {string} type
     * @param {function} trigger
     * @return {void}
    */
    EventDispatcher.prototype.addEventListner = function (type, trigger) {
        if (trigger === undefined) {
            return;
        }
        console.log(trigger + " added for " + type);
        if (this.listners[type] === undefined) {
            this.listners[type] = [];
        }
        this.removeEventListner(type, trigger);
        this.listners[type].push(trigger);
    };
    /**@description Remove this function from the current listnere type */
    EventDispatcher.prototype.removeEventListner = function (type, trigger) {
        if (trigger === undefined) {
            return;
        }
        if (this.listners[type] !== undefined) {
            var index = this.listners[type].indexOf(trigger);
            if (index >= 0) {
                this.listners[type].splice(index, 1);
            }
        }
    };
    /**@description Dispatch all triggers for this type of event
     * @param {string} type
     * @param {any}
     */
    EventDispatcher.prototype.dispatchEvent = function (type, param) {
        if (param === void 0) { param = null; }
        console.log("* dispatched : " + type);
        if (this.listners[type] !== undefined) {
            this.listners[type].forEach(function (item) { item(type, param); });
        }
    };
    return EventDispatcher;
}());
exports.default = EventDispatcher;
//# sourceMappingURL=EventDispatcher.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/saffroncodejs/lib/framework/EventDispatcher.js
// module id = 35
// module chunks = 0